module.exports = __webpack_public_path__ + "img/maestrolight.99c434c46532.svg";